import { C } from "@hikari/vault-core";

export default function Section({ id, eyebrow, title, subtitle, children, background }) {
    return (
        <section
            id={id}
            style={{
                padding: "5rem 1.5rem",
                background: background || "transparent",
                borderTop: background ? `1px solid ${C.border}` : "none",
            }}
        >
            <div style={{ maxWidth: "1040px", margin: "0 auto" }}>
                {eyebrow && (
                    <div
                        style={{
                            fontSize: "0.72rem",
                            letterSpacing: "0.3em",
                            color: C.accent,
                            marginBottom: "0.9rem",
                            fontFamily: C.font,
                        }}
                    >
                        {eyebrow}
                    </div>
                )}
                {title && (
                    <h2
                        style={{
                            fontSize: "clamp(1.6rem, 3.5vw, 2.4rem)",
                            fontWeight: 500,
                            margin: "0 0 1rem 0",
                            lineHeight: 1.2,
                            maxWidth: "24ch",
                            color: C.text,
                            fontFamily: C.font,
                        }}
                    >
                        {title}
                    </h2>
                )}
                {subtitle && (
                    <p
                        style={{
                            color: C.muted,
                            maxWidth: "60ch",
                            margin: "0 0 2.5rem 0",
                            lineHeight: 1.65,
                            fontFamily: C.font,
                            fontSize: "0.95rem",
                        }}
                    >
                        {subtitle}
                    </p>
                )}
                {children}
            </div>
        </section>
    );
}
